import Vue from "vue";
import VueRouter from "vue-router";
import loginPage from "../views/loginPage/loginPage.vue";
import { menuAuthMap, getFirstAuthRoute } from "@/router/menuMap";
Vue.use(VueRouter);

const routes = [
  // 登录
  { path: "/", name: "loginPage", component: loginPage },
  // 注册
  {
    path: "/signIn",
    name: "signIn",
    component: () => import("../views/loginPage/signIn.vue"),
  },
  // 系统菜单
  {
    path: "/systemMenu",
    component: () => import("../views/systemMenu/systemMenu.vue"),
    children: [
      // 个人中心
      {
        path: "individualCenter",
        name: "individualCenter",
        component: () =>
          import("../views/individualCenter/individualCenter.vue"),
      },
      // 智能柜模块
      {
        path: "",
        name: "cabinetModule",
        component: () => import("../views/cabinetModule/cabinetModule.vue"),
        children: [
          {
            path: "boundAlreadyCabinet",
            name: "boundAlreadyCabinet",
            component: () =>
              import(
                "../views/cabinetModule/boundAlreadyCabinet/boundAlreadyCabinet.vue"
              ),
          },
          {
            path: "cabinetCargoAisle",
            name: "cabinetCargoAisle",
            component: () =>
              import(
                "../views/cabinetModule/cabinetCargoAisle/cabinetCargoAisle.vue"
              ),
          },
          {
            path: "cabinetDocuments",
            name: "cabinetDocuments",
            component: () =>
              import(
                "../views/cabinetModule/cabinetDocuments/cabinetDocuments.vue"
              ),
          },
          {
            path: "cabinetMaterials",
            name: "cabinetMaterials",
            component: () =>
              import(
                "../views/cabinetModule/cabinetMaterials/cabinetMaterials.vue"
              ),
          },
          {
            path: "lowInventoryCargoAisle",
            name: "lowInventoryCargoAisle",
            component: () =>
              import(
                "../views/cabinetModule/lowInventoryCargoAisle/lowInventoryCargoAisle.vue"
              ),
          },
          {
            path: "cabinetUsers",
            name: "cabinetUsers",
            component: () =>
              import("../views/cabinetModule/cabinetUsers/cabinetUsers.vue"),
          },
          {
            path: "lowInventoryMaterials",
            name: "lowInventoryMaterials",
            component: () =>
              import(
                "../views/cabinetModule/lowInventoryMaterials/lowInventoryMaterials.vue"
              ),
          },
        ],
      },
      // 公司模块
      {
        path: "",
        name: "companyModule",
        component: () => import("../views/companyModule/companyModule.vue"),
        children: [
          {
            path: "companyMaterials",
            name: "companyMaterials",
            component: () =>
              import(
                "../views/companyModule/companyMaterials/companyMaterials.vue"
              ),
          },
          {
            path: "companyUser",
            name: "companyUser",
            component: () =>
              import("../views/companyModule/companyUser/companyUser.vue"),
          },
          {
            path: "companyCharacter",
            name: "companyCharacter",
            component: () =>
              import(
                "../views/companyModule/companyCharacter/companyCharacter.vue"
              ),
          },
          {
            path: "companyDepartment",
            name: "companyDepartment",
            component: () =>
              import(
                "../views/companyModule/companyDepartment/companyDepartment.vue"
              ),
          },
        ],
      },
      // 接口模块
      {
        path: "",
        name: "interfaceModule",
        component: () => import("../views/interfaceModule/interfaceModule.vue"),
        children: [
          {
            path: "tripartiteInterface",
            name: "tripartiteInterface",
            component: () =>
              import(
                "../views/interfaceModule/tripartiteInterface/tripartiteInterface.vue"
              ),
          },
          {
            path: "notSynchronizedData",
            name: "notSynchronizedData",
            component: () =>
              import(
                "../views/interfaceModule/notSynchronizedData/notSynchronizedData.vue"
              ),
          },
        ],
      },
      // 工单管理
      {
        path: "",
        name: "workOrderModule",
        component: () => import("../views/workOrderModule/workOrderModule.vue"),
        children: [
          {
            path: "workOrderDetails",
            name: "workOrderDetails",
            component: () =>
              import(
                "../views/workOrderModule/workOrderDetails/workOrderDetails.vue"
              ),
          },
          {
            path: "processedParts",
            name: "processedParts",
            component: () =>
              import(
                "../views/workOrderModule/processedParts/processedParts.vue"
              ),
          },
          {
            path: "machineTools",
            name: "machineTools",
            component: () =>
              import("../views/workOrderModule/machineTools/machineTools.vue"),
          },
          {
            path: "productionLine",
            name: "productionLine",
            component: () =>
              import(
                "../views/workOrderModule/productionLine/productionLine.vue"
              ),
          },
        ],
      },
      // 系统管理
      {
        path: "",
        name: "systemManagement",
        component: () =>
          import("../views/systemManagement/systemManagement.vue"),
        children: [
          {
            path: "allCabinet",
            name: "allCabinet",
            component: () =>
              import("../views/systemManagement/allCabinet/allCabinet.vue"),
          },
          {
            path: "mainAccount",
            name: "mainAccount",
            component: () =>
              import("../views/systemManagement/mainAccount/mainAccount.vue"),
          },
          {
            path: "mainAccountRole",
            name: "mainAccountRole",
            component: () =>
              import(
                "../views/systemManagement/mainAccountRole/mainAccountRole.vue"
              ),
          },
          {
            path: "setPermission",
            name: "setPermission",
            component: () =>
              import(
                "../views/systemManagement/setPermission/setPermission.vue"
              ),
          },
        ],
      },
    ],
  },
  // 401
  {
    path: "/401Page",
    name: "401Page",
    component: () => import("../views/401Page.vue"),
  },
  { path: "*", redirect: "/401Page" },
  // 空白页刷新
  { path: "/empty", name: "empty", component: { template: "<div></div>" } },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

// 不需要权限校验的白名单
const whiteList = ["/", "/signIn", "/401Page", "/empty"];

// 构建路径到权限码的映射表
const pathPermissionMap = {};
menuAuthMap.forEach((item) => {
  pathPermissionMap[item.path] = item.permission;
});

// 全局前置守卫
router.beforeEach((to, from, next) => {
  // 白名单直接放行
  if (whiteList.includes(to.path)) {
    next();
    return;
  }

  // 获取用户权限列表
  let permissions = [];
  const permissionStr = sessionStorage.getItem("permission_codes");
  if (permissionStr) {
    try {
      permissions = JSON.parse(permissionStr);
    } catch (e) {
      permissions = [];
    }
  }

  // 如果没有权限信息，说明未登录或登录失效，跳转401（或登录页，根据业务需求）
  if (!permissions || permissions.length === 0) {
    next("/401Page");
    return;
  }

  // 处理父级路径 /systemMenu：重定向到第一个有权限的子路由
  if (to.path === "/systemMenu") {
    const firstAuthPath = getFirstAuthRoute(permissions);
    if (firstAuthPath && firstAuthPath !== "/401Page") {
      next(firstAuthPath);
    } else {
      next("/401Page");
    }
    return;
  }

  // 检查当前路径是否需要权限
  const requiredPermission = pathPermissionMap[to.path];
  if (requiredPermission) {
    if (permissions.includes(requiredPermission)) {
      next();
    } else {
      next("/401Page");
    }
  } else {
    next();
  }
});

export default router;
